globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.EmailingSenderShow = (function(superClass) {

  utils.extend(EmailingSenderShow, superClass);

  function EmailingSenderShow() {
    return EmailingSenderShow.__super__.constructor.apply(this, arguments);
  }

  $.extend(EmailingSenderShow.prototype, {
    init: function() {
      var modal = this;
      var $loaderPlaceholder = modal.$html.find('.loader-placeholder');

      if ($loaderPlaceholder.length) {
        appCustomerSpace.Loader().start({
          $container: $loaderPlaceholder,
          options: { text: false, style: { spinner: { marginBottom: "0px" } } }
        });
      }

      return EmailingSenderShow.__super__.init.apply(this, arguments);
    },
    callbackSuccess: function(data) {
      if (data && data.response === 1) {
        this.close();
        if (data.notification_flash) {
          new appCustomerSpace.Modules.NotificationFlash($(data.notification_flash));
        }
      }
    }
  });

  return EmailingSenderShow;

})(appCustomerSpace.Modal);
